import React from 'react'
import Style from '../updates.module.css'

const STEPS = [
    { title: 'Pick your systems', text: 'Choose the ERP or eCommerce system to connect, then the integration you need.' },
    { title: 'Choose versions', text: 'Select both versions and a product type, and answer any prerequisites.' },
    { title: 'Install and sync', text: 'Download or run the installers, then watch records sync from the dashboard.' }
]

const GettingStarted = () => (
    <section className={Style.section} aria-labelledby="start-title">
        <div className={Style.sectionHeader}>
            <div>
                <h2 id="start-title" className={Style.sectionTitle}>Get your first connector running</h2>
                <p className={Style.sectionHint}>Three steps, all from New Connector.</p>
            </div>
        </div>
        <ol className={Style.steps}>
            {STEPS.map((step, index) => (
                <li key={step.title} className={Style.step}>
                    <span className={Style.stepNumber} aria-hidden="true">{index + 1}</span>
                    <div>
                        <p className={Style.stepTitle}>{step.title}</p>
                        <p className={Style.stepText}>{step.text}</p>
                    </div>
                </li>
            ))}
        </ol>
    </section>
)

export default GettingStarted
